import { css } from '@emotion/react';
import type { Theme } from '@resi-media/resi-ui';
import { List, useBreakpoint } from '@resi-media/resi-ui';

const SearchList = ({ children, isLoading, ...props }: List.Props & { isLoading?: boolean }) => {
  const mediaQuery = useBreakpoint();
  return (
    <List
      customCss={{
        container: (theme: Theme) => css`
          ${mediaQuery.lg && `border-radius: inherit;`}
          border: ${mediaQuery.lg ? `1px solid ${theme.palette.disabled.foreground}` : 'none'};
          border-top: none;
          box-shadow: none;
          overflow: hidden;
          ${isLoading && 'display: none;'}
        `,
      }}
      index={-1}
      isFullWidth
      sizeVariant="s"
      {...props}
    >
      {children}
    </List>
  );
};

SearchList.displayName = 'SearchList';

export { SearchList };
